import React from 'react'
import styled from 'styled-components'
import tw, { theme } from 'twin.macro'
import { useTranslation } from 'react-i18next'
import ExpandingTextarea from 'react-expanding-textarea'
import { h1 } from '@features/post/articleContentStyles'
import { TITLE_MAX_LENGTH } from '../../publish-setting/_shared'
import { useInputState } from '@hooks/useInputState'

interface TitleInputProps {
  onChange?: (value: string) => void
  onEnter?: () => void
  value?: string
}

export default function TitleInput(props: TitleInputProps) {
  const { t } = useTranslation('editor')
  const { onChange, onEnter, value } = props

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (!onEnter || e.key !== 'Enter') return

    e.preventDefault()
    onEnter()
  }

  const [[title], handleInputChange, handleInputComposingUpdate, handleInputFocusChange] =
    useInputState([
      {
        id: 'title',
        defaultValue: value,
        initialValue: value,
        onChange,
      },
    ])

  return (
    <>
      <StyledInput
        id="title"
        value={title.value}
        maxLength={TITLE_MAX_LENGTH}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        onCompositionStart={handleInputComposingUpdate}
        onCompositionEnd={handleInputComposingUpdate}
        onFocus={handleInputFocusChange}
        onBlur={handleInputFocusChange}
        placeholder={t(['titleInput.placeholder', '這裡輸入標題'])}
      />
      <Hint css={(title.status === 'focus' || title.status === 'maximum') && tw`flex`}>
        <span className="hint">
          {t(['titleInput.hint', '小提示：建議標題字數在 28~32 字之間，有助於 SEO 優化喔！'])}
        </span>
        <span
          className="counter"
          css={[
            title.status === 'maximum' && tw`text-secondary-close`,
            title.status !== 'maximum' && tw`text-gray-400`,
          ]}
        >
          {title.count} / {TITLE_MAX_LENGTH}
        </span>
      </Hint>
    </>
  )
}

const StyledInput = styled(ExpandingTextarea)`
  ${tw`border-0 outline-none resize-none block w-full`}
  ${h1} 
  caret-color: ${theme`colors.primary.indigo`};
  &::placeholder {
    ${tw`text-gray-200`};
  }
`

const Hint = styled.div`
  ${tw`hidden justify-between`}
  ${tw`text-c2-d leading-c2-d tracking-wide`}
  .hint {
    ${tw`text-primary-indigo`}
  }

  .counter {
    white-space: nowrap;
    margin-left: 20px;
  }
`
